<template>
  <section class="chat_audit_set">
    <h3>开启人工审核后，待审核聊天消息的分配方式：</h3>
    <div class="radio-group-wrapper">
      <vh-radio-group v-model="radioValue">
        <vh-radio label="1" class="custom-radio">
          <span class="radio-content">待审核聊天消息根据审核人员数量进行随机分配（默认）</span>
        </vh-radio>
        <vh-radio label="0" class="custom-radio">
          <span class="radio-content">每位审核人员可看到全部待审核消息</span>
        </vh-radio>
      </vh-radio-group>
    </div>

    <div class="button-wrapper">
      <vh-button type="primary" round class="save-button" @click="save">保存</vh-button>
    </div>

    <div class="notice">
      <div class="notice-title">提示：</div>
      <div class="notice-content">
        <p class="notice-item">1. 修改分配方式之后，请刷新人工审核页面，以保证审核数据是最新的</p>
        <p class="notice-item">
          2. 直播平台默认待审核聊天消息根据审核人数量随机分配，避免因多人审核出现重复审核的现象
        </p>
        <pc-preview class="notice-item">
          3. 如果需要每位审核人员看到的待审核消息一致，可选择「每位审核人员可看到全部待审核消息」
        </pc-preview>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    data() {
      return {
        radioValue: '1'
      };
    },
    methods: {
      getAuditSet() {
        this.$fetch('getChatAuditSet', { config_type: '10', config_subtype: '4' }).then(res => {
          if (res.code == 200) {
            this.radioValue = res.data?.config_value
              ? JSON.parse(res.data.config_value).bucket_switch
              : '1';
          }
        });
      },
      save() {
        this.$fetch('saveChatAuditSet', {
          config_type: '10',
          config_subtype: '4',
          config_value: JSON.stringify({ bucket_switch: this.radioValue })
        })
          .then(res => {
            if (res.code == 200) {
              this.$vhMessage.success('保存成功');
            }
          })
          .catch(error => {
            this.$vhMessage.error(error.message || '保存失败');
          });
      }
    },
    mounted() {
      this.getAuditSet();
    }
  };
</script>
<style scoped>
  .chat_audit_set {
    padding: 20px;
    background-color: #ffffff;
    border-radius: 4px;
  }

  h3 {
    margin-bottom: 20px;
    font-size: 16px;
    font-weight: 500;
    color: #333333;
  }

  .radio-group-wrapper {
    margin-bottom: 30px;
  }

  .custom-radio {
    margin-bottom: 15px;
    line-height: 24px;
  }

  .custom-radio:last-child {
    margin-bottom: 0;
  }

  .radio-content {
    font-size: 14px;
    color: #333333;
  }

  .button-wrapper {
    margin-bottom: 20px;
    text-align: center;
  }

  .save-button {
    width: 120px;
  }

  .notice {
    margin-top: 20px;
    padding: 10px;
    font-size: 12px;
    color: #999999;
    line-height: 17px;
  }

  .notice-title {
    margin-bottom: 8px;
    font-weight: 500;
  }

  .notice-item:last-child {
    margin-bottom: 0;
  }
</style>
